import _construct from "@babel/runtime/helpers/construct";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*
============
== POTREE ==
============

http://potree.org

Copyright (c) 2011-2020, Markus Schütz
All rights reserved.

    Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

    1. Redistributions of source code must retain the above copyright notice, this
list of conditions and the following disclaimer.
2. Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

    The views and conclusions contained in the software and documentation are those
of the authors and should not be interpreted as representing official policies,
    either expressed or implied, of the FreeBSD Project.
 */

import * as THREE from 'three';
import PointCloudLayer from "./PointCloudLayer";
import Potree2Node from "../Core/Potree2Node";
import Extent from "../Core/Geographic/Extent";
import { PointAttribute, Potree2PointAttributes, PointAttributeTypes } from "../Core/Potree2PointAttributes";
var bboxMesh = new THREE.Mesh();
var box3 = new THREE.Box3();
bboxMesh.geometry.boundingBox = box3;
var typeNameAttributeMap = {
  "double": PointAttributeTypes.DATA_TYPE_DOUBLE,
  "float": PointAttributeTypes.DATA_TYPE_FLOAT,
  int8: PointAttributeTypes.DATA_TYPE_INT8,
  uint8: PointAttributeTypes.DATA_TYPE_UINT8,
  int16: PointAttributeTypes.DATA_TYPE_INT16,
  uint16: PointAttributeTypes.DATA_TYPE_UINT16,
  int32: PointAttributeTypes.DATA_TYPE_INT32,
  uint32: PointAttributeTypes.DATA_TYPE_UINT32,
  int64: PointAttributeTypes.DATA_TYPE_INT64,
  uint64: PointAttributeTypes.DATA_TYPE_UINT64
};
function parseAttributes(jsonAttributes) {
  var attributes = new Potree2PointAttributes();
  var replacements = {
    rgb: 'rgba'
  };
  var _iterator = _createForOfIteratorHelper(jsonAttributes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var jsonAttribute = _step.value;
      var name = jsonAttribute.name,
        numElements = jsonAttribute.numElements,
        min = jsonAttribute.min,
        max = jsonAttribute.max;
      var type = typeNameAttributeMap[jsonAttribute.type];
      var potreeAttributeName = replacements[name] ? replacements[name] : name;
      var attribute = new PointAttribute(potreeAttributeName, type, numElements);
      if (numElements === 1) {
        attribute.range = [min[0], max[0]];
      } else {
        attribute.range = [min, max];
      }
      if (name === 'gps-time') {
        // HACK: Guard against bad gpsTime range in metadata, see potree/potree#909
        if (attribute.range[0] === attribute.range[1]) {
          attribute.range[1] += 1;
        }
      }
      attribute.initialRange = attribute.range;
      attributes.add(attribute);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  {
    // check if it has normals
    var hasNormals = attributes.attributes.find(function (a) {
      return a.name === 'NormalX';
    }) !== undefined && attributes.attributes.find(function (a) {
      return a.name === 'NormalY';
    }) !== undefined && attributes.attributes.find(function (a) {
      return a.name === 'NormalZ';
    }) !== undefined;
    if (hasNormals) {
      attributes.addVector({
        name: 'NORMAL',
        attributes: ['NormalX', 'NormalY', 'NormalZ']
      });
    }
  }
  return attributes;
}

/**
 * @property {boolean} isPotreeLayer - Used to checkout whether this layer
 * is a Potree2Layer. Default is `true`. You should not change this, as it is
 * used internally for optimisation.
 */
var Potree2Layer = /*#__PURE__*/function (_PointCloudLayer) {
  _inherits(Potree2Layer, _PointCloudLayer);
  var _super = _createSuper(Potree2Layer);
  /**
   * Constructs a new instance of Potree2 layer.
   *
   * @constructor
   * @extends PointCloudLayer
   *
   * @example
   * // Create a new point cloud layer
   * const points = new Potree2Layer('points',
   *  {
   *      source: new Potree2Source({
   *          url: 'https://pointsClouds/',
   *          file: 'metadata.json',
   *      }
   *  });
   *
   * View.prototype.addLayer.call(view, points);
   *
   * @param {string} id - The id of the layer, that should be unique. It is
   * not mandatory, but an error will be emitted if this layer is added a
   * {@link View} that already has a layer going by that id.
   * @param {Object} config - Configuration, all elements in it
   * will be merged as is in the layer. For example, if the configuration
   * contains three elements `name, protocol, extent`, these elements will be
   * available using `layer.name` or something else depending on the property
   * name. See the list of properties to know which one can be specified.
   * @param {string} [config.crs=ESPG:4326] - The CRS of the {@link View} this
   * layer will be attached to. This is used to determine the extent of this
   * layer.  Default to `EPSG:4326`.
   */
  function Potree2Layer(id, config) {
    var _this;
    _classCallCheck(this, Potree2Layer);
    _this = _super.call(this, id, config);
    _this.isPotreeLayer = true;
    var resolve = _this.addInitializationStep();
    _this.source.whenReady.then(function (metadata) {
      _this.scale = new THREE.Vector3(1, 1, 1);
      _this.metadata = metadata;
      _this.pointAttributes = parseAttributes(metadata.attributes);
      _this.spacing = metadata.spacing;
      var normal = Array.isArray(_this.pointAttributes.attributes) && _this.pointAttributes.attributes.find(function (elem) {
        return elem.name.startsWith('NORMAL');
      });
      if (normal) {
        _this.material.defines[normal.name] = 1;
      }
      var min = _construct(THREE.Vector3, _toConsumableArray(metadata.boundingBox.min));
      var max = _construct(THREE.Vector3, _toConsumableArray(metadata.boundingBox.max));
      var boundingBox = new THREE.Box3(min, max);
      var root = new Potree2Node(0, 0, _assertThisInitialized(_this));
      root.bbox = boundingBox;
      root.boundingSphere = boundingBox.getBoundingSphere(new THREE.Sphere());
      root.id = 'r';
      root.depth = 0;
      root.nodeType = 2;
      root.hierarchyByteOffset = 0n;
      root.hierarchyByteSize = BigInt(metadata.hierarchy.firstChunkSize);
      root.byteOffset = 0;
      _this.root = root;
      _this.extent = Extent.fromBox3(_this.source.crs || 'EPSG:4326', boundingBox);
      return _this.root.loadOctree().then(resolve);
    });
    return _this;
  }
  return _createClass(Potree2Layer);
}(PointCloudLayer);
export default Potree2Layer;